import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';

// Your web app's Firebase configuration
// Put your SDK details
const firebaseConfig = {

    apiKey: "AIzaSyCEUt-QfW8rYUxqM66qp6qGfZDuSfGWXfE",
  
    authDomain: "perleto-auth.firebaseapp.com",
  
    projectId: "perleto-auth",
  
    storageBucket: "perleto-auth.appspot.com",
  
    messagingSenderId: "1032151714400",
  
    appId: "1:1032151714400:web:4b7471454a842cd4a2d105"
  
  };
  

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore;
const auth = firebaseApp.auth();


export { auth, db };
export default firebase; 

// export var database;

// Initialize Provider & Export
export const microsoftProvider = new firebase.auth.OAuthProvider('microsoft.com').setCustomParameters({
  login_hint: '',
  tenant: 'common',  // Put Tenant Id from Azure registered app,
  prompt: 'consent' // Get Consent from user to access their basic info (optional - Reommended only during SignUp)
})